<template>
  <div>
    <h2 class="content-block-title">{{ title }}</h2>

    <dx-data-grid
      v-if="!loading"
      class="dx-card content-block"
      :data-source="dataSource"
      key-expr="domain"
      :focused-row-index="0"
      :show-borders="false"
      :focused-row-enabled="true"
      :column-auto-width="true"
      :column-hiding-enabled="true"
    >
      <dx-paging :page-size="20" />
      <dx-pager :show-page-size-selector="true" :show-info="true" :allowed-page-sizes="[5, 10, 20, 30, 50]" />
      <dx-filter-row :visible="true" />

      <dx-column data-field="domain" caption="Domain" />
      <!-- <dx-column data-field="url" caption="URL" /> -->
      <dx-column data-field="url" caption="URL" cell-template="urlCellTemplate" />
      <!-- <dx-column data-field="health_url" caption="Health URL" /> -->
      <!-- <dx-column data-field="subnet" caption="Subnet" /> -->
      <!-- <dx-column data-field="hostname_prefix" caption="Hostname Prefix" /> -->
      <dx-column data-field="server_name" caption="Server Name" />
      <dx-column data-field="server_name_ip" caption="Server IP" />
      <dx-column data-field="server_name_port" caption="Server Port" />
      <dx-column data-field="status" caption="Status" cell-template="statusCell" />
      <dx-column data-field="acl" caption="ACL" />
      <dx-column data-field="backend" caption="Backend" />

      <!-- Template for URL -->
      <template #urlCellTemplate="{ data }">
        <a
          :href="data.value"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ data.value.replace(/^https?:\/\//, '') }}
        </a>
      </template>

      <template #statusCell="{ data }">
        <span :class="['tag-pill', data.value === 'ok' ? 'tag-ok' : 'tag-error']">
          {{ data.value }}
        </span>
      </template>
    </dx-data-grid>

    <div v-if="loading" class="loading-overlay">
      <DxLoadIndicator :height="60" :width="60" />
    </div>
  </div>
</template>

<script>
  import {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxPager,
    DxFilterRow
  } from 'devextreme-vue/data-grid';
  import { DxLoadIndicator } from 'devextreme-vue/load-indicator';
  import axios from 'axios';

  export default {
    name: 'HAProxyCertMappings',
    components: {
      DxDataGrid,
      DxColumn,
      DxPaging,
      DxPager,
      DxFilterRow,
      DxLoadIndicator
    },
    data() {
      return {
        title: 'HAProxy Certificate Mappings',
        loading: true,
        dataSource: []
      };
    },
    mounted() {
      this.loadMappings();
    },
    methods: {


      async loadMappings() {
        try {
          const response = await axios.get('/api/internal/haproxy/mappings/with-status');
          const data = response.data || {};
          const mappings = Array.isArray(data.mappings) ? data.mappings : [];

          this.dataSource = mappings.map(entry => {
            const [serverName = '', ipPort = ''] = entry.server || [];
            const [ip = '', port = ''] = ipPort.split(':');

            return {
              ...entry,
              server_name: serverName,
              server_name_ip: ip,
              server_name_port: port
            };
          });
        } catch (error) {
          console.error('Error fetching HAProxy mappings:', error);
          this.dataSource = [];
        } finally {
          this.loading = false;
        }
      }



      // async loadMappings() {
      //   try {
      //     // const response = await fetch('/internal/haproxy/mappings/with-status');
      //     const response = await axios.get('/api/internal/haproxy/mappings/with-status');
      //     // const data = await response.json();
      //     // const data = await response.data;
      //     const data = Array.isArray(response.data) ? response.data : [];


      //     this.dataSource = data.mappings.map(entry => {
      //     //   const [serverName = '', ipPort = '', check = ''] = entry.server || [];
      //       const [serverName = '', ipPort = ''] = entry.server || [];
      //       const [ip = '', port = ''] = ipPort.split(':');
      //       return {
      //         ...entry,
      //         server_name: serverName,
      //         server_name_ip: ip,
      //         server_name_port: port
      //       };
      //     });
      //   } catch (error) {
      //     console.error('Error fetching mappings:', error);
      //   } finally {
      //     this.loading = false;
      //   }
      // }

      // async loadMappings() {
      //   try {
      //     const response = await axios.get('/api/internal/haproxy/config');
      //     const data = response.data || {};

      //     const flatMappings = [];

      //     (data.sections || []).forEach(section => {
      //       const sectionName = section.name || 'Unknown Section';

      //       (section.content || []).forEach(line => {
      //         if (line.startsWith('use_backend')) {
      //           const parts = line.split(' ');
      //           const backend = parts[1] || '';
      //           const condition = parts.slice(2).join(' ') || '';

      //           flatMappings.push({
      //             domain: sectionName,
      //             acl: condition,
      //             backend: backend,
      //             status: data.valid ? 'ok' : 'error',
      //           });
      //         }
      //       });
      //     });

      //     this.dataSource = flatMappings;
      //   } catch (error) {
      //     console.error('Error fetching HAProxy config:', error);
      //     this.dataSource = [];
      //   } finally {
      //     this.loading = false;
      //   }
      // }

    }
  };
</script>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 100px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 10;
}

.tag-pill {
  display: inline-block;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  color: white;
}

.tag-ok {
  background-color: #4caf50;
}

.tag-warning {
  background-color: #ff9800;
}

.tag-expired {
  background-color: #f44336;
}

.tag-error {
  background-color: #d32f2f;
}
</style>
